module.exports = __webpack_public_path__ + "static/gabriel-059eb00e8c45da28e9021924d907950b.jpg";